/**
 * InterviewTimer Component - Countdown Timer Display
 * Optimized with React.memo
 */
import React, { memo } from "react";
import { Clock } from "lucide-react";
import { formatTime } from "./constants";

const InterviewTimer = memo(({ timeRemaining, isRunning, totalTime = 180 }) => {
  const percentage = totalTime > 0 ? (timeRemaining / totalTime) * 100 : 0;
  const isLowTime = timeRemaining <= 30;
  const isCriticalTime = timeRemaining <= 10;
  
  return (
    <div className={`p-4 rounded-xl border-2 transition-all duration-300 ${
      isCriticalTime ? 'border-red-500 bg-red-50 animate-pulse' :
      isLowTime ? 'border-orange-500 bg-orange-50' :
      isRunning ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-gray-50'
    }`}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Clock className={`w-5 h-5 ${
            isCriticalTime ? 'text-red-600 animate-bounce' :
            isLowTime ? 'text-orange-600' :
            isRunning ? 'text-blue-600' : 'text-gray-600'
          }`} />
          <span className="font-medium text-gray-800">Time Remaining</span>
        </div>
      </div>
      
      {/* Time Display */}
      <div className="text-center my-3">
        <span className={`text-4xl font-bold font-mono ${
          isCriticalTime ? 'text-red-600' :
          isLowTime ? 'text-orange-600' :
          'text-blue-600'
        }`}>
          {formatTime(timeRemaining)}
        </span>
      </div>
      
      {/* Progress Bar */}
      <div className="relative h-3 bg-gray-200 rounded-full overflow-hidden">
        <div 
          className={`h-full transition-all duration-1000 rounded-full ${
            isCriticalTime ? 'bg-red-500' :
            isLowTime ? 'bg-orange-500' :
            'bg-blue-500'
          }`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      {/* Warning Text */}
      {isLowTime && (
        <p className={`text-center text-xs mt-2 font-medium ${
          isCriticalTime ? 'text-red-600' : 'text-orange-600'
        }`}>
          {isCriticalTime ? 'Wrap up now!' : 'Time running low'}
        </p>
      )}
    </div>
  );
});

InterviewTimer.displayName = "InterviewTimer";

export default InterviewTimer;
